import { Button, Form, Modal } from "react-bootstrap";
import { FeedbackButton } from "../../Commons/Functions";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';

export default function DiceModal(props) {
    const [result, setResult] = useState({ id: "", res: -1 })
    const [customFaces, setCustomFaces] = useState(7)

    function rollDice(faces) {
        let res = Math.floor(Math.random() * faces) + 1;
        setResult({ id: uuidv4(), val: res })
        props.sendToHistory("rolled a " + res + "/" + faces)
    }

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Dice</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ opacity: result.val > 0 ? 1 : 0 }} className="w-100 d-flex justify-content-center align-items-center dice-result">
                    <h1 key={result.id} className="">{result.val}</h1>
                </div>
                <p>Choose a dice to roll:</p>
                <div className="d-flex flex-column">
                    {[2, 4, 6, 8, 10, 12, 20].map(faces => (
                        <FeedbackButton key={faces} duration={200} className='my-1' onClick={() => rollDice(faces)} feedBack="Rolled !">{faces}</FeedbackButton>
                    ))}
                    <div className="d-flex my-3">
                        <Form.Control
                            className="w-25"
                            type="number"
                            value={customFaces}
                            id="custom-dice-faces"
                            onChange={(e) => {
                                setCustomFaces(e.target.value)
                            }}
                        />
                        <FeedbackButton key={"custom"} duration={200} className='ms-1 w-100' onClick={() => rollDice(customFaces)} feedBack="Rolled !">{customFaces}</FeedbackButton>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}